<section>
  <div class="container-fluid py-4 px-4">

    <div class="container-fluid container-card mb-4">
      <h1 class="heading-1">Golf Statistics</h1>

      <div class="row">
        <div class="col-12 col-md-12 col-lg-4 mb-3 mb-sm-3 mb-lg-0">  <!--TW20250924-->
          <div class="card card-revenue">
            <div class="card-header">
              <h5 class="card-title card-title-custom">
                <img src="assets/icons/occupancy-lease.png"> Total Revenue
              </h5>
            </div>
            <div class="card-body card-body-custom align-items-center">
              <div class="container-fluid container-box-progress mt-3">
                <div class="row">
                  <div class="col-6 col-md-6 d-flex flex-column justify-content-center">
                    <span class="title-date">
                      {{ startDate_Renenue | dateformat }} - {{ endDate_Revenue | dateformat }}
                    </span>
                    <span class="title-percent-progress mt-1">
                      {{ ItemTotalRevenue.pct_usage }}%
                    </span>
                  </div>
                  <div class="col-12 col-md-6 col-lg-6 d-flex justify-content-end">
                    <div class="d-flex flex-column align-items-end">
                      <h5 class="title-under-badge d-flex">
                        <div [ngSwitch]="true">
                          <i *ngSwitchCase="ItemTotalRevenue.pct_from_prev === 0" class="percent-success"></i>
                          <i *ngSwitchCase="ItemTotalRevenue.pct_from_prev && ItemTotalRevenue.pct_from_prev.toString().startsWith('-')"
                            class="fas fa-arrow-down fa-xs" style="color: var(--color-red-dark);"></i>
                          <i *ngSwitchDefault class="fas fa-arrow-up fa-xs" style="color: var(--color-green-dark);"></i>
                        </div>
                        <div [ngSwitch]="true">
                          <span *ngSwitchCase="ItemTotalRevenue.pct_from_prev === 0" class="percent-success">{{
                            ItemTotalRevenue.pct_from_prev }}</span>
                          <span
                            *ngSwitchCase="ItemTotalRevenue.pct_from_prev && ItemTotalRevenue.pct_from_prev.toString().startsWith('-')"
                            class="percent-danger">{{ ItemTotalRevenue.pct_from_prev }}</span>
                          <span *ngSwitchDefault class="percent-success">+{{ ItemTotalRevenue.pct_from_prev }}</span>
                          
                        </div>
                      </h5>
                      <span class="title-under-badge d-flex">
                        <span> {{ ItemTotalRevenue.remarks }}</span>
                      </span>
                    </div>


                  </div>
                </div>
              </div>

              <div class="card-body">
                <div class="chart-wrapper">
                  <div class="chart-container">
                    <div id="chart">
                      <div *ngIf="isLoadingTotalRevenue" class="text-center p-4">
                        <div class="spinner-border" role="status">
                          <span class="visually-hidden">Loading Total Revenue data...</span>
                        </div>
                      </div>

                      <apx-chart *ngIf="!isLoadingTotalRevenue" [series]="chartOptions.series"
                        [chart]="chartOptions.chart" [dataLabels]="chartOptions.dataLabels"
                        [plotOptions]="chartOptions.plotOptions" [yaxis]="chartOptions.yaxis"
                        [xaxis]="chartOptions.xaxis" [legend]="chartOptions.legend" [colors]="chartOptions.colors"
                        [grid]="chartOptions.grid">
                      </apx-chart>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>

        <div class="col-12 col-md-12 col-lg-3 mb-3 mb-sm-3 mb-lg-0">
          <div class="card card-tenant">
            <div class="card-header">
              <h5 class="card-title card-title-custom">
                <img src="assets/icons/tenant.png"> Membership
              </h5>
            </div>
            <div class="card-body card-body-custom">

              <div class="container box-tenant-count h-60">   <!--TW20250925-->
                <h5 class="text-tenant-count text-center">{{ ItemMembership.total }}</h5>
              </div>
            </div>
            <div class="card-footer">
              <div class="row my-3" *ngFor="let item of ItemMembership.members; trackBy: trackByMemberName">
                <div class="col-6 col-md-6 col-lg-6 d-flex justify-content-start">
                  <div class="form-group">
                    <h5 class="text-tenant-group">{{ item.name }}</h5>
                  </div>
                </div>
                <div class="col-6 col-md-6 col-lg-6 d-flex justify-content-end">
                  <div class="form-group">
                    <h5 class="text-group-count">{{ item.num_member }}</h5>
                  </div>
                </div>
              </div>


            </div>
            <!-- TW20250925 -->
            <div class="card-header">
              <h5 class="card-title card-title-custom">
                <img src="assets/icons/revenue-lease.png"> Round
              </h5>
            </div>
            <div class="card-body card-body-custom">

              <div class="container box-tenant-count h-60">
                <h5 class="text-tenant-count text-center">{{ ItemRound.total }}</h5>
              </div>
            </div>
            <div class="card-footer">
              <div class="row my-3" *ngFor="let item of ItemRound.members; trackBy: trackByMemberName">
                <div class="col-6 col-md-6 col-lg-6 d-flex justify-content-start">
                  <div class="form-group">
                    <h5 class="text-tenant-group">{{ item.title }}</h5>
                  </div>
                </div>
                <div class="col-6 col-md-6 col-lg-6 d-flex justify-content-end">
                  <div class="form-group">
                    <h5 class="text-group-count">{{ item.num_round }}</h5>
                  </div>
                </div>
              </div>
            </div>
            <!-- End of TW20250925 -->
          </div>
        </div>

        <div class="col-12 col-md-12 col-lg-4 mb-3 mb-sm-3 mb-lg-0">  <!--TW20250924-->
          <div class="card card-revenue">
            <div class="card-header">
              <h5 class="card-title card-title-custom">
                <img src="assets/icons/revenue-lease.png"> Revenue
              </h5>
            </div>
            <div class="card-body card-body-custom card-body-overflow ">
              <div *ngIf="!isLoading && revenueItem.length > 0">
                <div class="container-box-lease" *ngFor="let item of revenueItem">
                  <div class="row">
                    <div class="col-6 col-md-6 col-lg-6">
                      <h5 class="title-revenue">{{ item.revenue_name }}</h5>
                      <h5 class="price-revenue"> {{ item.revenue_value | rupiah }} </h5>
                    </div>
                    <div class="col-6 col-md-6 col-lg-6 d-flex justify-content-end">
                      <div class="d-flex flex-column align-items-end">

                        <div [ngSwitch]="true">
                          <!-- Kondisi 1: Jika nilai adalah 0, hilangkan ikon arrow dan gunakan class success -->
                          <span *ngSwitchCase="item.budget_pct === 0" class="badge custom-progress-success">
                            {{ item.budget_pct }}
                          </span>

                          <!-- Kondisi 2: Jika nilai dimulai dengan "-", gunakan ikon down arrow dan class danger -->
                          <span *ngSwitchCase="item.budget_pct && item.budget_pct.toString().startsWith('-')"
                            class="badge custom-progress-danger">
                            <i class="fas fa-arrow-down fa-md" style="color: var(--color-red-dark)"></i> {{
                            item.budget_pct }}
                          </span>

                          <!-- Kondisi 3: Untuk nilai lainnya, tambahkan "+" di depan dan gunakan class success -->
                          <span *ngSwitchDefault class="badge custom-progress-success">
                            <i class="fas fa-arrow-up fa-md" style="color: var(--color-green-dark)"></i> +{{
                            item.budget_pct }}%
                          </span>
                        </div>

                        <h5 class="title-under-badge">{{ item.remarks }}</h5>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="container-box-lease d-flex justify-content-center"
                *ngIf="!isLoading && revenueItem.length === 0">
                <div class="spinner-border text-success" role="status">
                  <span class="visually-hidden">Loading...</span>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>

    </div>

    <div class="container-fluid container-card">
      <div class="row g-3">
        <div class="col-12 col-lg-6">
          <h1 class="heading-1">Golf Membership</h1>
        </div>
        <div class="col-12 col-md-8 col-lg-4">
          <div class="form-group group-input">
            <input type="text" class="form-control" placeholder="Type Member Name" [(ngModel)]="searchTerm"
              (keyup)="onSearch($event)" [value]="searchTerm">
            <img src="assets/icons/search.png" alt="">
          </div>
        </div>
        <div class="col-12 col-md-4 col-lg-2">
          <div class="custom-dropdown">
            <div class="dropdown">
              <button class="btn btn-outlet-success-custom w-100" data-bs-toggle="dropdown" aria-expanded="false"
                data-bs-auto-close="outside">
                {{ selectedMemberType }} <i class="fa-solid fa-chevron-down fa-xs"></i>
              </button>

              <ul class="dropdown-menu show-custom p-4">
                <li>
                  <a class="dropdown-item" (click)="resetMemberTypeFilter()"
                    [class.active]="selectedMemberType === 'All Member Type'">
                    All Member Type
                  </a>
                </li>

                <li *ngFor="let item of ItemMemberType">
                  <a class="dropdown-item" (click)="onMemberTypeFilter(item.id, item.name)"
                    [class.active]="selectedMemberType === item.name">
                    {{ item.name }}
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div class="table-responsive my-3 p-0 d-none d-lg-block">
        <table class="table table-striped text-nowrap">
          <thead>
            <tr>
              <th class="sortable-header" (click)="onSort('member_name')">
                <span>Member Name</span>
                <img [src]="getSortIcon('member_name')" alt="sort" class="sort-icon">
              </th>
              <th class="text-center sortable-header" (click)="onSort('status')">
                <span>Status</span>
                <img [src]="getSortIcon('status')" alt="sort" class="sort-icon">
              </th>
              <th class="text-center sortable-header" (click)="onSort('member_type')">
                <span>Member Type</span>
                <img [src]="getSortIcon('member_type')" alt="sort" class="sort-icon">
              </th>
              <th class="text-center sortable-header" (click)="onSort('join_date')">
                <span>Join Date</span>
                <img [src]="getSortIcon('join_date')" alt="sort" class="sort-icon">
              </th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of displayedData">
              <td>{{ item.member_name }}</td>
              <td class="text-center">
                <span class="badge" [ngClass]="{
                    'badge-success-custom': item.status === 'Active',
                    'badge-warning-custom': item.status === 'Suspend',
                    'badge-danger-custom': item.status === 'Inactive'
                  }">
                  {{ item.status }}
                </span>
              </td>
              <td class="text-center">{{ item.member_type }}</td>
              <td class="text-center">{{ item.join_date|dateformat }}</td>
            </tr>

          </tbody>

          <tbody *ngIf="isLoading">
            <tr>
              <td colspan="6" class="text-center">
                <div class="spinner-border text-success" role="status">
                  <span class="visually-hidden">Loading...</span>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="my-4 d-block d-sm-block d-md-block d-lg-none">

        <div class="card card-sm-custom my-3" [ngClass]="{'border bg-light': i % 2 !== 0}" role="button" tabindex="0"
          *ngFor="let item of displayedData; let i = index">
          <div class="card-header card-sm-header">
            <h5>{{ item.member_name }}</h5>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-5">
                <div class="card-sm-title">Status</div>
                <div class="card-sm-title">Member Type</div>
                <div class="card-sm-title">Join Date</div>
              </div>
              <div class="col-7">
                <div class="card-sm-title">
                  <span class="badge" [ngClass]="{
                    'badge-success-custom': item.status === 'Active',
                    'badge-warning-custom': item.status === 'Suspend',
                    'badge-danger-custom': item.status === 'Inactive'
                  }">
                    {{ item.status }}
                  </span>
                </div>
                <div class="card-sm-title">{{ item.member_type }}</div>
                <div class="card-sm-title">{{ item.join_date|dateformat }}</div>
              </div>
            </div>
          </div>

          <div class="card-body d-flex justify-content-center" *ngIf="isLoading">
            <div class="spinner-border text-success text-center" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
          </div>
        </div>

      </div>

      <div class="row">

        <div class="col-12 col-md-12 col-lg-6 total-page-number">
          <h5 class="pageCount">
            Displaying
            <span class="perPage">
              {{ displayRange.start | number }} - {{ displayRange.end | number }}
            </span>
            out of
            <span class="totalPerPage">
              {{ displayRange.total | number }}
            </span>
          </h5>
        </div>

        <div class="col-12 col-md-12 col-lg-6 page-pagination">

          <nav aria-label="Page navigation">
            <ul class="pagination">
              <li class="page-item" [class.disabled]="paginationConfig.currentPage === 1">
                <a class="page-link first-page" href="javascript:void(0)" (click)="onFirstPage()" aria-label="First">
                  <span aria-hidden="true">&laquo;</span>
                </a>
              </li>
              <li class="page-item" [class.disabled]="paginationConfig.currentPage === 1">
                <a class="page-link prev-page" href="javascript:void(0)" (click)="onPrevPage()" aria-label="Previous">
                  <span aria-hidden="true">&lsaquo;</span>
                </a>
              </li>
              <li class="page-item" *ngFor="let page of pageNumbers"
                [class.active]="page === paginationConfig.currentPage">
                <a class="page-link" href="javascript:void(0)" (click)="onPageChange(page)">{{ page }}</a>
              </li>
              <li class="page-item" [class.disabled]="paginationConfig.currentPage === totalPages">
                <a class="page-link next-page" href="javascript:void(0)" (click)="onNextPage()" aria-label="Next">
                  <span aria-hidden="true">&rsaquo;</span>
                </a>
              </li>
              <li class="page-item" [class.disabled]="paginationConfig.currentPage === totalPages">
                <a class="page-link last-page" href="javascript:void(0)" (click)="onLastPage()" aria-label="Last">
                  <span aria-hidden="true">&raquo;</span>
                </a>
              </li>
            </ul>
          </nav>

        </div>
      </div>
    </div>

  </div>
</section>
